import React from "react";
import { useState } from "react";
import { api } from 'api';

/**
 * Hook para realizar peticiones a la API relacionadas a las recepciones compartidas con contenedores.
 * @returns {Object} Objeto con las funciones y estados necesarios para las recepciones compartidas con contenedores.
 */
export const ResumenApi = () => {
    const [cargando, setCargando] = useState(false);

    // OBTENER RECEPCIONES DE VIAJE
    const [recepciones, setRecepciones] = useState([]);

    const getRecepcionesViaje = async (params) => {
        try {
            setCargando(true);
            const response = await api.get('recepciones_contenedores/get_recepciones_viaje', params);
            if (!response) return [];

            setRecepciones(response)
            return response;
        } catch (error) {
            console.error(error);
            setRecepciones([]);
            return [];
        } finally {
            setCargando(false);
        }
    }

    return {
        getRecepcionesViaje,
        recepciones,

        cargando,
    }
}
